// ElementCard.tsx - Element Card Component
// Periodic table style card - symbol, name, effect, cost

import { TrendingUp, Zap } from 'lucide-react'
import { Element } from '../../types/element'

interface ElementCardProps {
  element: Element
  onClick?: () => void
}

export default function ElementCard({ element, onClick }: ElementCardProps) {
  return (
    <div
      onClick={onClick}
      className="card cursor-pointer hover:shadow-lg transition-all"
      style={{
        background: element.color || 'var(--card-bg)',
        border: '2px solid var(--border-color)',
        borderRadius: '8px',
        padding: '16px',
        position: 'relative',
        overflow: 'hidden'
      }}
    >
      {/* Symbol (buyuk) */}
      <div
        className="text-4xl font-bold mb-2 text-center"
        style={{
          color: 'white',
          textShadow: '2px 2px 4px rgba(0,0,0,0.3)'
        }}
      >
        {element.symbol}
      </div>

      {/* Name */}
      <div
        className="text-sm font-semibold text-center mb-3"
        style={{
          color: 'white',
          textShadow: '1px 1px 2px rgba(0,0,0,0.3)'
        }}
      >
        {element.name}
      </div>

      {/* Effect */}
      {element.effect && (
        <div
          className="flex items-center gap-2 mb-2 text-xs"
          style={{
            background: 'rgba(255,255,255,0.2)',
            padding: '6px 8px',
            borderRadius: '4px',
            color: 'white'
          }}
        >
          <TrendingUp size={14} />
          <span>{element.effect}</span>
        </div>
      )}

      {/* Boost Percentage */}
      {element.boost_percentage > 0 && (
        <div
          className="flex items-center gap-2 mb-2 text-xs font-bold"
          style={{
            background: 'rgba(255,255,255,0.3)',
            padding: '6px 8px',
            borderRadius: '4px',
            color: 'white'
          }}
        >
          <Zap size={14} />
          <span>+{element.boost_percentage}% Boost</span>
        </div>
      )}

      {/* Cost */}
      <div
        className="text-center text-sm font-bold mt-2"
        style={{
          color: 'white',
          textShadow: '1px 1px 2px rgba(0,0,0,0.3)'
        }}
      >
        {element.cost_flz} FLZ
      </div>

      {/* Category badge (sag ust kose) */}
      {element.category_id && (
        <div
          className="absolute top-2 right-2 text-xs px-2 py-1 rounded"
          style={{
            background: 'rgba(0,0,0,0.3)',
            color: 'white'
          }}
        >
          {element.category_id}
        </div>
      )}
    </div>
  )
}
